import { DataBean } from "../../DataBean";


export class HealthRegimen extends DataBean {


    public async getHealthRegimen(args:any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.account.HealthRegimen_getHealthRegimen_Number", [args]);
    }

    public async getHealthRegimenCatalog(type:any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getHealthRegimenCatalog_Number", [type]);
    }

}